module.exports = __webpack_public_path__ + "media/images/icons/twotone/hdd-da56f2dbaa97ff0032cd7fe1b09e66cb.svg";